import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { SwitchTabItem } from './components/switch-tab-item';
import * as Styled from './styles';
import type { SwitchTabProps as Props } from './types';

export const SwitchTab = memo(
  ({
    className,
    options,
    activeProps = { variant: 'outlined', color: 'primary' },
    inActiveProps = { variant: 'outlined', color: 'inherit' },
  }: Props) => {
    return (
      <Styled.Wrapper className={classnames('SwitchTab ', className)}>
        {options.map((opt) => (
          <SwitchTabItem
            key={opt.key}
            item={opt}
            activeProps={activeProps}
            inActiveProps={inActiveProps}
          />
        ))}
      </Styled.Wrapper>
    );
  }
);

SwitchTab.displayName = 'SwitchTab';
